import { render, staticRenderFns } from "./AdminCustomerContractButton.vue?vue&type=template&id=b0afb5aa"
import script from "./AdminCustomerContractButton.vue?vue&type=script&lang=js"
export * from "./AdminCustomerContractButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports